import CreditScoringLayout from '@/modules/credit-scoring/layout/CreditScoringLayout.vue';

const routes = [
  {
    path: 'dashboard',
    name: 'dashboard',
    meta: {
      requiredPrivileges: ['Access Credit Scoring']
    },
    component: () => import('@/modules/credit-scoring/views/Dashboard.vue')
  },
  {
    path: 'upload-data',
    name: 'upload-data',
    meta: {
      requiredPrivileges: ['Access Credit Scoring', 'Upload File']
    },
    component: () => import('@/modules/credit-scoring/views/UploadData.vue')
  },
  {
    path: 'mass-report',
    name: 'mass-report',
    meta: {
      requiredPrivileges: ['Access Credit Scoring', 'Generate Report']
    },
    component: () => import('@/modules/credit-scoring/views/MassReport.vue')
  },
  {
    path: 'view-reports',
    name: 'view-reports',
    meta: {
      requiredPrivileges: ['Access Credit Scoring', 'View Report']
    },
    component: () => import('@/modules/credit-scoring/views/ViewReports.vue')
  },
  {
    path: 'risk-rating-settings',
    name: 'risk-rating-settings',
    meta: {
      requiredPrivileges: ['Access Credit Scoring', 'View Risk Rating Settings']
    },
    component: () =>
      import('@/modules/credit-scoring/views/RiskRatingSettings.vue')
  }
];

export default {
  path: 'credit-scoring',
  name: 'credit-scoring',
  component: CreditScoringLayout,
  redirect: {
    name: 'dashboard'
  },
  meta: {
    requiresAuth: true,
    requiredPrivileges: ['Access Credit Scoring']
  },
  children: [...routes]
};
